import { useEffect, useState } from 'react';
import { Autocomplete, OptionType } from '@parspec/pixel';
import { IRichCellEditorParams } from 'ag-grid-community';
import { CustomCellEditorProps } from 'ag-grid-react';
import { ParspecMfgDetailsResponse } from 'src/features/Settings/Manufacturer/queries/apiTypes';

type AutocompleteEditorProps = IRichCellEditorParams & CustomCellEditorProps;
interface Manufacturer {
    manufacturer_name: string;
}
const AutocompleteEditor = (props: AutocompleteEditorProps) => {
    const [inputValue, setInputValue] = useState<string | null>('');
    const [open, setOpen] = useState(false);

    const updateValue = (val: string) => {
        setInputValue(val === '' ? null : val);
        props.onValueChange(val === '' ? null : val);
    };

    useEffect(() => {
        let startValue;
        let highlightAllOnFocus = true;
        if (props.eventKey && props.eventKey.length === 1) {
            // if a letter was pressed, we start with the letter
            startValue = props.eventKey;
            highlightAllOnFocus = false;
        }
        if (startValue == null) {
            startValue = '';
        }
        updateValue(startValue);
        const mfgNameElement = document.querySelector('.MuiInputBase-input.MuiAutocomplete-inputFocused') as HTMLElement;
        if (mfgNameElement) {
            mfgNameElement.focus();
            if (mfgNameElement instanceof HTMLInputElement && highlightAllOnFocus) {
                setInputValue(props.value);
                props.onValueChange(props.value === '' ? null : props.value);
                mfgNameElement.select();
            }
        }
    }, []);

    //MuiInputBase-input
    useEffect(() => {
        const handleGridScroll = () => {
            setOpen(false);
        };

        props.api.addEventListener('bodyScroll', handleGridScroll);

        return () => {
            props.api.removeEventListener('bodyScroll', handleGridScroll);
        };
    }, [props.api]);

    useEffect(() => {
        // Automatically open the dropdown when the editor is first rendered
        setOpen(true);
    }, []);

    const handleChange = (event: React.SyntheticEvent<Element, Event>) => {
        const target = event.target as HTMLInputElement;
        const selectedValue = target.value as unknown as Manufacturer;
        if (!selectedValue || !selectedValue.manufacturer_name) return;
        updateValue(selectedValue.manufacturer_name);
        setOpen(false);
    };

    const handleInputChange = (event: React.SyntheticEvent, newInputValue: string) => {
        props.onValueChange(newInputValue === '' ? null : newInputValue);
    };

    return (
        <Autocomplete
            open={open}
            onOpen={() => setOpen(true)}
            onBlur={() => setOpen(false)}
            freeSolo
            label=""
            optionlabelkeyname="manufacturer_name"
            value={inputValue}
            onTextFieldChange={handleInputChange}
            onChange={handleChange}
            autoFocus
            searchingKeys={['parspec_id', 'abbreviation_str']}
            options={props?.values as OptionType<ParspecMfgDetailsResponse>[]}
        />
    );
};

export default AutocompleteEditor;
